export default "__VITE_ASSET__DJ39wTwt__"